import type { RouteRecordName } from "vue-router";

/**
 * Routes the HOST owns when embedded: the signed-in user's own account, and the org settings the
 * shell manages. Nav items are hidden via `hideWhenEmbedded`, but a URL still resolves — this is
 * what closes the deep link. Connections is deliberately absent: it is mailbox onboarding, i.e.
 * product config rather than org management.
 */
export const SHELL_OWNED_ROUTE_NAMES: ReadonlySet<string> = new Set([
  // Customer browsing: the shell's own Manage customers owns this surface.
  "mspOverview",
  "msp-customers",
  "mspSettings",
  "msp-settings-administrators",
  "msp-settings-branding",
  "msp-settings-saml-sso",
  "customer-settings-administrators",
  "customer-settings-saml-sso",
  "system-settings-saml-sso",
]);

type ResolvedLocation = { path: string; name?: RouteRecordName | null };

// The whole `/profile` area, by path: its parent record redirects and carries no name of its own.
export const isShellOwnedRoute = (to: ResolvedLocation): boolean =>
  to.path.startsWith("/profile") ||
  (typeof to.name === "string" && SHELL_OWNED_ROUTE_NAMES.has(to.name));

export default isShellOwnedRoute;
